import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  categoryexts: [],
  categoryext: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_CATEGORYEXTS (state, payload) {
    state.categoryexts = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  SET_CATEGORYEXT (state, payload) {
    state.categoryext = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  categoryExtList: (context, id) => {
    return Vue.http.get(`${env.API}/api/category-ext`)    
      .then((response) => {      
        context.commit('SET_CATEGORYEXTS', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  paginatedList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/category-ext/paginated-list`, data)    
      .then((response) => {        
        context.commit('SET_CATEGORYEXTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  },
  deleteCategoryExt: (context, data) => {
    return Vue.http.delete(`${env.API}/api/category-ext/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  getCategoryExtById: (context, id) => {
    return Vue.http.get(`${env.API}/api/category-ext/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_CATEGORYEXT', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCategoryExt: (context, data) => {
    return Vue.http.put(`${env.API}/api/category-ext/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createCategoryExt: (context, data) => {
    return Vue.http.post(`${env.API}/api/category-ext`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateSortAd: (context, data) => {
    return context.commit('SET_SORT_AD', data)
  }
}

const getters = {
  getCategoryExts: (state) => state.categoryexts,
  getCategoryExt: (state) => state.categoryext,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const categoryext = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categoryext.js